import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { shareRoadtrip } from '../services/api'; // Assurez-vous d'importer la fonction d'API

const ShareRoadtripModal = ({ show, handleClose, roadtrip }) => {
    const [email, setEmail] = useState('');
    const [error, setError] = useState(null);
    const [successMessage, setSuccessMessage] = useState('');
    const shareLink = `https://rt.anthonybois.fr/roadtrip/${roadtrip.roadtrip_id}?token=${roadtrip.share_token}`;
    const handleShareReadWrite = async () => {
        setError(null);
        setSuccessMessage('');

        try {
            const response = await shareRoadtrip(roadtrip.roadtrip_id, email, false); // false pour lecture/écriture
            if (response.success) {
                setSuccessMessage('Roadtrip partagé avec succès !');
                setEmail('');
            } else {
                setError(response.message);
            }
        } catch (err) {
            setError('Erreur lors du partage du roadtrip');
        }
    };

    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Partager le Roadtrip</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {error && <div className="alert alert-danger">{error}</div>}
                {successMessage && <div className="alert alert-success">{successMessage}</div>}
                
                <div>
                    <div className="mt-2">
                        <p>Voici votre lien de partage (lecture seul):</p>
                        <div class="input-group mb-3">
                            <input type="text" value={shareLink} readOnly className="form-control" />
                            <Button variant="secondary" onClick={() => navigator.clipboard.writeText(shareLink)}>
                                Copier
                            </Button>
                        </div>
                    </div>
                </div>

                <div className="mt-4">
                    <h5>Partager en lecture/écriture</h5>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>Adresse e-mail</Form.Label>
                            <div class="input-group mb-3">
                            <Form.Control
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="Entrez l'adresse e-mail"
                                required
                            />
                                <Button variant="secondary" onClick={handleShareReadWrite}>
                                    Partager
                                </Button>
                            </div>
                        </Form.Group>
                    </Form>
                </div>
                {roadtrip.shared_emails && (
                    <div className="mt-4">
                        <h5>Adresses e-mail partagées</h5>
                        <ul>
                            {roadtrip.shared_emails.split(',').map((email, index) => (
                                <li key={index}>{email.trim()}</li>
                            ))}
                        </ul>
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Fermer
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ShareRoadtripModal; 